<template>
  <list-page>
    <h1 slot="model">产品分类</h1>
    <h3 slot="model_y">PRODUCT CATEGORY</h3>
    <template slot="list">
      <list>
        <div class="producttitle" slot="title">
          <h2>整车控制器</h2>
          <p>Vehicle-controller</p>
          <div class="More_box">
            <router-link class="element" :to="'/ProductList/1'"><span>MORE</span></router-link>
          </div>
        </div>
        <div slot="listitem">
          <el-skeleton :loading="loading1" class="imgview">
            <template slot="template">
              <list-item-gj></list-item-gj>
              <list-item-gj></list-item-gj>
              <list-item-gj></list-item-gj>
            </template>
            <template>
              <router-link :to="'/ProductCategoryDetail/'+ item.id" target="_blank"
                v-for="(item,index) in moodsImg1" :key="index"
                v-if="index < 3">
                <list-item :item="item"></list-item>
              </router-link>
            </template>
          </el-skeleton>
        </div>
      </list>
      <list v-if="moodsImg2.length != 0">
        <div class="producttitle" slot="title">
          <h2>电驱动与传动系统</h2>
          <p>Electric-drive-and-transmission-system</p>
          <div class="More_box">
            <router-link class="element" :to="'/ProductList/2'"><span>MORE</span></router-link>
          </div>
        </div>
        <div class="imgview" slot="listitem">
          <router-link :to="'/ProductCategoryDetail/'+ item.id" target="_blank"
            v-for="(item,index) in moodsImg2" :key="index"
            v-if="index < 3">
            <list-item :item="item"></list-item>
          </router-link>
        </div>
      </list>
      <list v-if="moodsImg3.length != 0">
        <div class="producttitle" slot="title">
          <h2>高压集成控制器</h2>
          <p>High-voltage-integrated-controller</p>
          <div class="More_box">
            <router-link class="element" :to="'/ProductList/3'"><span>MORE</span></router-link>
          </div>
        </div>
        <div class="imgview" slot="listitem">
          <router-link :to="'/ProductCategoryDetail/'+ item.id" target="_blank"
            v-for="(item,index) in moodsImg3" :key="index"
            v-if="index < 3">
            <list-item :item="item"></list-item>
          </router-link>
        </div>
      </list>
      <list v-if="moodsImg4.length != 0">
        <div class="producttitle" slot="title">
          <h2>其他高压附件</h2>
          <p>Other-high-voltage-accessories</p>
          <div class="More_box">
            <router-link class="element" :to="'/ProductList/4'"><span>MORE</span></router-link>
          </div>
        </div>
        <div class="imgview" slot="listitem">
          <router-link :to="'/ProductCategoryDetail/'+ item.id" target="_blank"
            v-for="(item,index) in moodsImg4" :key="index"
            v-if="index < 3">
            <list-item :item="item"></list-item>
          </router-link>
        </div>
      </list>
    </template>
  </list-page>
</template>
  
<script>
  import listPage from '@/view/components/listPage.vue'
  import list from '@/view/components/list.vue'
  import listItem from '@/view/components/listItemProduct.vue'
  import listItemGj from '@/view/components/listItemProductGj.vue'

import News from '@/api/api.js'
export default {
  data() {
    return {
      moodsImg1: [],
      moodsImg2: [],
      moodsImg3: [],
      moodsImg4: [],
      
      loading1: true,
    };
  },
  components: {
    listPage,
    list,
    listItem,
    listItemGj
  },
  created() {
    this.getData(1)
    this.getData(2)
    this.getData(3)
    this.getData(4)
  },
  mounted() {
  },
  methods: {
    async getData(classId){
      this.searchDTO={
        limit: 3,
        classId
      };
      let res =await News.getProductList(this.searchDTO);
      this['moodsImg'+classId] = res.data;
      this['loading'+classId] = false
      // console.log('moodsImg'+classId,this['moodsImg'+classId])
    }
  },
};
</script>
  
<style lang="scss"  scoped >
.wrap > div {
  padding-bottom: 40px;
}
.wrap > div:nth-child(1) {
  background-color: rgb(7, 55, 99);
  .More_box .element {
    background-color: rgb(7, 55, 99);
  }
}
.wrap > div:nth-child(2) {
  background-color: rgb(74, 134, 232);
  .More_box .element {
    background-color: rgb(74, 134, 232);
  }
}
.wrap > div:nth-child(3) {
  background-color: rgb(0, 0, 0);
  .More_box .element {
    background-color: rgb(0, 0, 0);
  }
}
.wrap > div:nth-child(4) {
  background-color: rgb(46, 82, 90);
}
.imgview {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  &::after {
      content: ""; 
      width: calc((100% - 0px) / 3);
  }
  a {
    width: calc(100%/3);
    border-radius: 4px;
    transition: .6s;
    &:hover {
      background: rgba(0,0,0,0.3);
    }
  }
}
/deep/ .el-skeleton {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
}
</style>


// WEBPACK FOOTER //
// src/view/webapp/ProductCategoryAll.vue